import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

let defaultStyles = {
    container: {
        position: 'relative',
        marginHorizontal: Theme.primaryMargin,
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'stretch',
        alignItems: 'stretch',
        backgroundColor: 'transparent'
    },
    title: {
        fontFamily: Theme.regularFont,
        fontSize: 25,
        marginHorizontal: 18,
        marginBottom: 10,
        color: Theme.primaryTextColor,
        textAlign: 'center'
    },
    message: {
        marginTop: 25,
        color: Theme.secondaryTextColor,
        paddingHorizontal: 30,
        lineHeight: 30,
        fontSize: 20,
        textAlign: 'center'
    },
    pinInputWrapper: {
        marginVertical: 25,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row'
    },
    pinInput: {
        width: 60,
        height: 60,
        textAlign: 'center',
        fontSize: 30,
        color: 'black',
        borderRadius: 5,
        marginHorizontal: 10,
        backgroundColor: '#FFFFFF'
    },
    forgotPin: {
        textAlign: 'center',
        paddingBottom: 30
    },
    defaultPinMessage: {
        color: '#FFFFFF',
        textAlign: 'center',
        paddingHorizontal: 14,
        fontSize: 16,
        lineHeight: 26
    },
    alert: {
        position: 'absolute',
        paddingHorizontal: 20,
        left: 0,
        right: 0,
        padding: 0,
        marginHorizontal: -Theme.primaryMargin - 6, // to extend innerContainer over whole viewport
        marginRight: -Theme.primaryMargin - 1 // Right side was getting cut off
    },
    webPinInput: {
        fontFamily: 'password'
    }
};

if (Device.isAndroid) {
    defaultStyles = {
        ...defaultStyles,
        alert: {
            ...defaultStyles.alert,
            marginTop: 'auto'
        }
    };
}

if (Device.isWeb) {
    defaultStyles = {
        ...defaultStyles,
        alert: {
            ...defaultStyles.alert,
            position: 'absolute',
            left: 0,
            right: 0
        }
    };
}

export default StyleSheet.create(defaultStyles);
